import { render, staticRenderFns } from "./usermessage.vue?vue&type=template&id=5003a98b&scoped=true"
import script from "./usermessage.vue?vue&type=script&lang=js"
export * from "./usermessage.vue?vue&type=script&lang=js"
import style0 from "./usermessage.vue?vue&type=style&index=0&id=5003a98b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003a98b",
  null
  
)

export default component.exports